export default __webpack_public_path__ + "static/media/flow_image.946e59c0.jpeg";